import React from "react";
import classNames from "classnames";
import "./UniversalLoader.scss";

const UniversalLoader = ({
  label,
  labelColor,
  preloaderColor,
  preloaderBgColor,
  position,
  isWithoutContainerBg
}) => {
  return (
    <div
      className={classNames({
        "loader__container": true,
        "loader__container--withoutBg": isWithoutContainerBg,
      })}
    >
      {!!label &&
        <div
          className={classNames({
            "loader__label": true,
            "loader__label-gray5": labelColor === 'gray5',
          })}
        >
          {label}
        </div>
      }

      <div
        className={classNames({
          "loader": true,
          "loader_color--black": preloaderColor === 'black',
          "loader_bgcolor--gray5": preloaderBgColor === 'gray5',
          "loader_bgcolor--blue-dark": preloaderBgColor === 'blue-dark',
          "loader_position--center": position === 'center',
        })}
      />
    </div>
  );
};

export default UniversalLoader;
